<div
  class="container"
  [ngClass]="{
    container_carousel: !disableCarousel && (showCarousel | async)
  }"
>
  <div
    *ngIf="!hideTitle"
    class="container__title"
  >
    <lib-image-title type="books">東京メトロのオリジナル絵本</lib-image-title>
  </div>
  <div class="container__content">
    <app-books
      *ngIf="disableCarousel || !(showCarousel | async)"
      [books]="books"
      (buttonClick)="onButtonClick($event)"
    ></app-books>
    <app-carousel
      *ngIf="!disableCarousel && (showCarousel | async)"
      [books]="books"
      (buttonClick)="onButtonClick($event)"
    ></app-carousel>
  </div>
</div>
